export interface quickFiltersT {
  id: number;
  title: string;
  value: string;
}

export const quickFiltersData: Array<quickFiltersT> = [
  {id: 0, title: 'همه', value: ''},
  {id: 1, title: 'پیگیری نشده', value: 'not_followed=1'},
  {id: 2, title: 'امروز', value: 'period=today'},
  {id: 3, title: '۳ روز آینده', value: 'period=3days'},
  {id: 4, title: '۷ روز آینده', value: 'period=7days'},
];
